import React, { FunctionComponent, PropsWithChildren } from 'react'
import { EsidProvider } from './EsidContext'
import { UserJourneySink } from './sink'
import { UserJourneyContext } from './UserJourneyContext'
import { UserJourneyReporting } from './UserJourneyReporting'
import { UserJourneyStateSync } from './UserJourneyStateSync'
import { useUserJourney } from './useUserJourney'

export interface UserJourneyProviderProps {
  /** Overrides the Datadog sink — used by tests and, later, the Path A service sink */
  sink?: UserJourneySink
}

/** Must be mounted inside the Redux Provider (UserJourneyStateSync dispatches to the store). */
export const UserJourneyProvider: FunctionComponent<PropsWithChildren<UserJourneyProviderProps>> = ({ children, sink }) => {
  const userJourney = useUserJourney()

  return (
    <EsidProvider>
      <UserJourneyContext.Provider value={userJourney}>
        {/* Order is load-bearing: UserJourneyReporting must mount (and subscribe) before
            any page anchor in {children} dispatches — a resume dispatched before the
            subscription exists would be silently unreported */}
        <UserJourneyStateSync />
        <UserJourneyReporting sink={sink} />
        {children}
      </UserJourneyContext.Provider>
    </EsidProvider>
  )
}
